import { render, staticRenderFns } from "./Home.data-manager-af.vue?vue&type=template&id=ea4eddd4&scoped=true&"
import script from "./Home.data-manager-af.vue?vue&type=script&lang=js&"
export * from "./Home.data-manager-af.vue?vue&type=script&lang=js&"
import style0 from "./Home.data-manager-af.vue?vue&type=style&index=0&id=ea4eddd4&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ea4eddd4",
  null
  
)

export default component.exports